import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes';

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: 'current-menu-item',
  linkExactActiveClass: 'current-menu-item'
});

// Show loader on every route change
router.beforeEach((to, from, next) => {
  if (window.showLoader) window.showLoader();
  next();
});


/**
 * FIXED AFTEREACH LOGIC
 *
 * The key idea:
 * - Wait until app is mounted (router.isReady)
 * - Register a ONE-TIME listener for content-ready
 * - If no component emits after 3s → hide loader anyway
 */

router.afterEach(async () => {
  // Wait until Vue app is mounted (this fixes refresh issue!)
  await router.isReady();

  // Access emitter safely
  const emitter = router.app?.config?.globalProperties?.$emitter;

  if (!emitter) {
    // Emergency fallback (very rare)
    setTimeout(() => window.hideLoader?.(), 3000);
    return;
  }

  // Fallback timeout (ONLY used if component never emits)
  const fallback = setTimeout(() => {
    window.hideLoader?.();
  }, 3000);

  // Listen once
  const off = emitter.on("content-ready", () => {
    clearTimeout(fallback);
    window.hideLoader?.();
    off(); // remove listener
  });
});

export default router;
